import chatMessage from './chat-message';
import chatTime from './chat-time';

export default {
    chatMessage,
    chatTime
}
